import { Copy, Save, Rocket, Tag } from "lucide-react";

function FieldBlock({ label, hint, children, onCopy, testid }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-sm font-semibold text-[#5c4634]">{label}</span>
        <div className="flex items-center gap-3">
          {hint && <span className="text-xs text-[#8c735f]">{hint}</span>}
          {onCopy && (
            <button onClick={onCopy} className="text-xs text-[#f0791f] flex items-center gap-1 hover:text-[#d9640d]" data-testid={testid}>
              <Copy size={13} /> Copiar
            </button>
          )}
        </div>
      </div>
      {children}
    </div>
  );
}

const INPUT_CLS =
  "w-full rounded-xl border border-[#e8d8c8] px-4 py-3 text-[#2e1e10] outline-none focus:border-[#f0791f] focus:ring-2 focus:ring-[#f0791f]/20";

export function ListingFields({ form, setForm, saving, onSave, onPublish, onCopy }) {
  return (
    <div className="space-y-5">
      <FieldBlock label="Título" hint={`${form.title.length}/120`} testid="title-copy" onCopy={() => onCopy(form.title, "Título")}>
        <input value={form.title} maxLength={120} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="title-input" className={INPUT_CLS} />
      </FieldBlock>

      <FieldBlock label="Categoria Shopee" testid="category-copy" onCopy={() => onCopy(form.category, "Categoria")}>
        <input value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} data-testid="category-input" className={INPUT_CLS} />
      </FieldBlock>

      <FieldBlock label="Descrição" testid="description-copy" onCopy={() => onCopy(form.description, "Descrição")}>
        <textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} rows={9} data-testid="description-input" className={`${INPUT_CLS} text-sm leading-relaxed`} />
      </FieldBlock>

      <FieldBlock label="Tags de busca">
        <input value={form.tags} onChange={(e) => setForm({ ...form, tags: e.target.value })} data-testid="tags-input" placeholder="separadas por vírgula" className={INPUT_CLS} />
      </FieldBlock>

      <FieldBlock label="Código de barras (GTIN/EAN) — opcional">
        <input value={form.gtin} onChange={(e) => setForm({ ...form, gtin: e.target.value })} data-testid="gtin-input" placeholder="preencha manualmente se tiver" className={INPUT_CLS} />
        <p className="mt-1.5 text-xs text-[#8c735f] flex items-center gap-1"><Tag size={12} /> A Solange nunca inventa esse número.</p>
      </FieldBlock>

      <div className="flex flex-col sm:flex-row gap-3 pt-2">
        <button onClick={onSave} disabled={saving} className="flex-1 py-3.5 rounded-full font-semibold border-2 border-[#c17f3e] text-[#9c5f27] hover:bg-[#f5ebe1] transition flex items-center justify-center gap-2 disabled:opacity-60" data-testid="save-btn">
          <Save size={18} /> {saving ? "Salvando..." : "Salvar alterações"}
        </button>
        <button onClick={onPublish} className="btn-orange flex-1 py-3.5 rounded-full font-semibold flex items-center justify-center gap-2" data-testid="publish-btn">
          <Rocket size={18} /> Marcar como publicado
        </button>
      </div>
    </div>
  );
}
